export default __webpack_public_path__ + "static/media/steps__slider-img-4.3f54d5bc.png";